module.exports = __webpack_public_path__ + "static/media/sign-in-bg.e43cc626.png";